import { jsx } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { memo } from "react";
import Grid from "../../../../node_modules/@mui/material/Grid/Grid.es.js";
import { Displaying } from "../../../foundations/displaying.es.js";
import { Alignment } from "../../../foundations/alignment.es.js";
function PriceSectionBuilder({
  price
}) {
  return /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, display: Displaying.flex, alignItems: Alignment.center, "data-testid": "card-container-price-section", children: price });
}
const ProductCardPrice = memo(PriceSectionBuilder);
export {
  ProductCardPrice
};
//# sourceMappingURL=product-card-price.es.js.map
